export const iconFontAwesomeEnergySeedling = (
	<i className="fa-solid fa-seedling"></i>
);
